// extracted by mini-css-extract-plugin
module.exports = {"registerLoginButtons":"RegisterLoginButtons_registerLoginButtons__2-0Wo"};